import { IRootState, IFilter, IFilterGrouping } from '@/store/types/IRootState';
import { FilterType } from './FilterMutations';

const categoryFilterMutations = {
    cleanCategoryFilters(state: IRootState) {
        state.categoryFilters.groupings = [];
    },
    checkCategoryFilter(state: IRootState, { id }: { id: string } ) {
        const filters = state.categoryFilters.groupings.flatMap(g => g.filters);
        const category = filters.find(f => f.value === id)
            || filters.flatMap(f => f.subfilters || []).find(f => f.value === id);

        if (category) {
            category.checked = !category.checked;
        }

        state.currentMaxItems = state.defaultMaxItems;
    },
    populateCategoryFilters(state: IRootState, { categories }: IPopulateCategoryFiltersPayload) {
        buildGroupings(state, categories);
    },
    toggleShowAllCategoryFilters(state: IRootState) {
        state.categoryFilters.showAllFilters = !state.categoryFilters.showAllFilters;
    },
    toggleShowFilterGroupCategoryFlag(state: IRootState) {
        state.categoryFilters.showFilterGroup = !state.categoryFilters.showFilterGroup;
    },
    toggleCategoryFilter(state: IRootState,  { name }: IToggleCategoryFilterPayload) {
        const group = state.categoryFilters.groupings.find((g: IFilterGrouping) => g.name === name);
        if (group) {
            group.isCollapsed = !group.isCollapsed;
        }
    },
};

export default categoryFilterMutations;

export interface IPopulateCategoryFiltersPayload {
    categories: Category[];
}

export interface IToggleCategoryFilterPayload {
    name: string;
}

export interface Category {
    id: number;
    name: string;
    count: number;
    parentId: number | null;
    group: string;
}

function buildGroupings(state: IRootState, categories: Category[]) {
    state.categoryFilters.groupings = state.categoryFilters.groupings.concat(
            categories
                .map((category: Category) => category.group)
                .filter((item, i, arr) => arr.indexOf(item) === i)
                .filter(group => !state.categoryFilters.groupings.some(f => f.name === group))
                .map((name: string) => ({ name, filters: [], count: 0, isCollapsed: false } as IFilterGrouping)),
        )
        .map(buildFilters(categories))
        .sort((a: IFilterGrouping, b: IFilterGrouping) => b.count - a.count);
}

function buildFilters(categories: Category[]): (value: IFilterGrouping) => IFilterGrouping {
    return (grouping: IFilterGrouping) => {
        grouping.filters = grouping.filters.concat(categories
            .filter(category => !category.parentId
                && category.group === grouping.name
                && !grouping.filters.some(f => f.value === category.id.toString()))
            .map((category: Category) => ({
                name: category.name,
                checked: false,
                value: category.id.toString(),
                count: category.count,
                type: FilterType.Categorias,
                subfilters: [],
            } as IFilter)))
            .map(buildSubfilters(categories))
            .sort((a: IFilter, b: IFilter) => b.count - a.count);

        grouping.count = grouping.filters.reduce((total, filter) => total + filter.count, 0);

        return grouping;
    };
}

function buildSubfilters(categories: Category[]): (filter: IFilter) => IFilter {
    return (filter: IFilter) => {
        filter.subfilters = (filter.subfilters || [])
            .concat(categories
                .filter((c: Category) => c.parentId && c.parentId.toString() === filter.value)
                .filter((c: Category) => !(filter.subfilters || []).some((s: IFilter) => s.value === c.id.toString()))
                .map((category: Category) => ({
                    name: category.name,
                    checked: false,
                    value: category.id.toString(),
                    count: category.count,
                    type: FilterType.Categorias,
                } as IFilter))).sort((a: IFilter, b: IFilter) => b.count - a.count);

        return filter;
    };
}
